import { GetCurrentUser } from "@/graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";

export const GetCurrentUserDetails = {
  data() {
    return {
      getCurrentUserDetailsObject: {},
      overlay: false,
      user_type: "",
    };
  },
  methods: {
    async GetCurrentUser() {
      try {
        this.overlay = true;
        this.hasaccessRoutesList = [];
        // let Email = "";
        // let PhoneNumber = "";
        // if (this.$store.getters.get_user_email != "") {
        //   Email = this.$store.getters.get_user_email;
        // } else if (this.$store.getters.get_phone_number != "") {
        //   PhoneNumber = this.$store.getters.get_phone_number;
        // }
        // let inputparams = {};
        let result = await API.graphql(
          graphqlOperation(GetCurrentUser, {
            input: {
              user_email_id:
                this.$store.getters.get_user_email != undefined &&
                this.$store.getters.get_user_email != ""
                  ? this.$store.getters.get_user_email.trim()
                  : undefined,
              // user_phone_number:
              //   this.$store.getters.get_phone_number != undefined &&
              //   this.$store.getters.get_phone_number != ""
              //     ? this.$store.getters.get_phone_number
              //     : undefined,
            },
          })
        );
        this.getCurrentUserDetailsObject = JSON.parse(
          result.data.GetCurrentUser
        ).response;
        console.log(
          "this.getCurrentUserDetailsObject",
          this.getCurrentUserDetailsObject
        );
        this.$store.commit(
          "SET_CURRENTUSER_DETAILS",
          this.getCurrentUserDetailsObject
        );

        setTimeout(() => {
          if (this.getCurrentUserDetailsObject.badge_number != undefined) {
            this.$store.commit("SET_SUBSCRIPTION_STATUS", true);
            console.log("Going In");
          }
        }, 1000);
        this.$store.commit("SET_CURRENT_LOCATION", true);
        // this.$router.push("/PlateLookUp");
        this.overlay = false;
        return "SUCCESS";
      } catch (error) {
        console.log("Check error", error);
        this.overlay = false;
        this.$router.push("/");
        return "ERROR";
      }
    },
  },
};
